module.exports = __webpack_public_path__ + "static/media/members.70e67732.svg";